import { connect, Dispatch } from 'react-redux';

import { AppState } from '../..';
import {
  createRealEstateAgent,
  CreateRealEstateAgentSuccessAction,
  editRealEstateAgent,
  getRealEstateAgent,
  EditRealEstateAgentSuccessAction
} from '../realestate-agent.actions';
import { RealEstateAgentComponent, RealEstateAgentComponentProperties } from './realestate-agent.component';
import { realEstateOfficesService } from '@services/RealEstateOfficesService';

export interface RealEstateAgentProperties {
  isViewOnly: boolean;
  saveCallback: Function;
}

// This is used to translate the state of the page to the props on the component
function mapStateToProps(
  state: AppState,
  ownProps: RealEstateAgentProperties
): Partial<RealEstateAgentComponentProperties> {
  return {
    errorMessage: state.realEstateAgent.errorMessage,
    id: state.realEstateAgent.id,
    isViewOnly: ownProps.isViewOnly,
    viewOnlyContracts: state.realEstateAgent.viewOnlyContracts,
    saving: state.realEstateAgent.saving
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: RealEstateAgentProperties
): Partial<RealEstateAgentComponentProperties> {
  return {
    submit: (formData, isModal) => {
      var val = parseInt('' + formData.id, 10);
      if ((formData.id && formData.id !== null && val > 0) || (val === 0 && '' + formData.id === '0')) {
        return dispatch(editRealEstateAgent(formData, isModal)).then((erasa: EditRealEstateAgentSuccessAction) => {
          if (ownProps.saveCallback) {
            ownProps.saveCallback(erasa.createdID);
          }
        });
      }
      formData = {
        ...formData,
        id: undefined
      };
      return dispatch(createRealEstateAgent(formData, isModal)).then((crasa: CreateRealEstateAgentSuccessAction) => {
        if (ownProps.saveCallback) {
          ownProps.saveCallback(crasa.createdID);
        }
      });
    },
    getRealEstateAgentInfo: (id?: number) => {
      return dispatch(getRealEstateAgent(id));
    },
    officeLookup(value: string, id: number) {
      return realEstateOfficesService.search([id], undefined, undefined, 1, 100, value);
    }
    /*  toggleViewOnly() {
              return dispatch(toggleViewOnly(null, null));
          },
         getCustomerDetails(id: number) {
              return customerService.getCustomer(id);
          }*/
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const RealEstateAgent = connect(
  mapStateToProps,
  mapDispatchToProps
)(RealEstateAgentComponent);



// WEBPACK FOOTER //
// ./src/realestate-agent/_components/realestate-agent.container.ts